import { defineFlagDefinitions } from './types';

export const flagDefinitions = defineFlagDefinitions({
  /**
   * Enable loyalty homepage
   * @see {@link https://app.launchdarkly.com/projects/default/flags/fhs-enable-loyalty-homepage LaunchDarkly Flag}
   */
  'enable-loyalty-homepage': {
    key: 'fhs-enable-loyalty-homepage',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable simply auth flow
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-simply-auth-flow LaunchDarkly Flag}
   */
  'enable-simply-auth-flow': {
    key: 'enable-simply-auth-flow',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable simply better cart service
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-simply-better-cart-service LaunchDarkly Flag}
   */
  'enable-simply-better-cart-service': {
    key: 'enable-simply-better-cart-service',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Zero Cart Total Order
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-zero-cart-total-order/targeting?env=dev-fhs&env=prod-fhs&env=prod-fhs-ca&env=qa-fhs&env=qa-fhs-ca&selected-env=qa-fhs-ca
   */
  'enable-zero-cart-total-order': {
    key: 'enable-zero-cart-total-order',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable Checkout page with fresh update
   * @see {@link https://app.launchdarkly.com/projects/default/flags/checkout-page-with-fresh-update LaunchDarkly Flag}
   */
  'checkout-page-with-fresh-update': {
    key: 'checkout-page-with-fresh-update',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable simply offer UI
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-simply-offer-ui LaunchDarkly Flag}
   */
  'enable-simply-offer-ui': {
    key: 'enable-simply-offer-ui',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable challenges
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-challenge-ui LaunchDarkly Flag}
   */
  'enable-challenge-ui': {
    key: 'enable-challenge-ui',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable simplified menu inside guide offers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-simplified-menu-inside-guide-offers LaunchDarkly Flag}
   */
  'enable-simplified-menu-inside-guide-offers': {
    key: 'enable-simplified-menu-inside-guide-offers',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Rewards Tiers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-rewards-tiers LaunchDarkly Flag}
   */
  'enable-rewards-tiers': {
    key: 'enable-rewards-tiers',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Configure ASAP pickup thresholds
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-asap-pickup-threshold LaunchDarkly Flag}
   * @todo why is this named enable-* if it's a number?
   */
  'enable-asap-pickup-threshold': {
    key: 'enable-asap-pickup-threshold',
    type: 'number',
    defaultValue: 0,
  },

  /**
   * Enable extra instructions on item
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-extra-instructions-on-item LaunchDarkly Flag}
   */
  'enable-extra-instructions-on-item': {
    key: 'enable-extra-instructions-on-item',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Autofill test card
   * @see {@link https://app.launchdarkly.com/projects/default/flags/autoFillTestCard LaunchDarkly Flag}
   */
  'autofill-test-card': {
    key: 'autoFillTestCard',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Curbside vehicle description max length
   * @see {@link https://app.launchdarkly.com/projects/default/flags/curbsideVehicleDescriptionMaxLength LaunchDarkly Flag}
   */
  'curbside-vehicle-description-max-length': {
    key: 'curbsideVehicleDescriptionMaxLength',
    type: 'number',
    defaultValue: 17,
  },

  /**
   * Datadog log sample rate
   * @see {@link https://app.launchdarkly.com/projects/default/flags/datadogLogSampleRate LaunchDarkly Flag}
   */
  'datadog-log-sample-rate': {
    key: 'datadogLogSampleRate',
    type: 'number',
    defaultValue: 100,
  },

  /**
   * Datadog RUM sample rate
   * @see {@link https://app.launchdarkly.com/projects/default/flags/datadogRumSampleRate LaunchDarkly Flag}
   */
  'datadog-rum-sample-rate': {
    key: 'datadogRumSampleRate',
    type: 'number',
    defaultValue: 0,
  },

  /**
   * Default service mode in store
   * @see {@link https://app.launchdarkly.com/projects/default/flags/defaultServiceModeInStore LaunchDarkly Flag}
   */
  'default-service-mode-in-store': {
    key: 'defaultServiceModeInStore',
    type: 'string',
    defaultValue: 'DISABLED',
  },

  /**
   * Delivery radius in miles
   * @see {@link https://app.launchdarkly.com/projects/default/flags/deliveryRadiusInMiles LaunchDarkly Flag}
   */
  'delivery-radius-in-miles': {
    key: 'deliveryRadiusInMiles',
    type: 'number',
    defaultValue: 10,
  },

  /**
   * Disable dine in
   * @see {@link https://app.launchdarkly.com/projects/default/flags/disableDineIn LaunchDarkly Flag}
   * @todo is this needed?
   */
  'disable-dine-in': {
    key: 'disableDineIn',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Disable drive thru
   * @see {@link https://app.launchdarkly.com/projects/default/flags/disableDriveThru LaunchDarkly Flag}
   * @todo is this needed?
   */
  'disable-drive-thru': {
    key: 'disableDriveThru',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Disable take out
   * @see {@link https://app.launchdarkly.com/projects/default/flags/disableTakeOut LaunchDarkly Flag}
   * @todo is this needed?
   */
  'disable-take-out': {
    key: 'disableTakeOut',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable accept terms on sign in (temporary)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-accept-terms-on-sign-in-tmp LaunchDarkly Flag}
   */
  'enable-accept-terms-on-sign-in-temp': {
    key: 'enable-accept-terms-on-sign-in-tmp',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable account delete OneTrust
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableAccountDeleteOneTrust LaunchDarkly Flag}
   */
  'enable-account-delete-one-trust': {
    key: 'enableAccountDeleteOneTrust',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Apple Pay
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableApplePay LaunchDarkly Flag}
   */
  'enable-apple-pay': {
    key: 'enableApplePay',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable closing time dialog
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-closing-time-dialog LaunchDarkly Flag}
   */
  'enable-closing-time-dialog': {
    key: 'enable-closing-time-dialog',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable cash payment
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-cash-payment LaunchDarkly Flag}
   */
  'enable-cash-payment': {
    key: 'enable-cash-payment',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable catering
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableCatering LaunchDarkly Flag}
   */
  'enable-catering': {
    key: 'enableCatering',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable catering delivery
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableCateringDelivery LaunchDarkly Flag}
   */
  'enable-catering-delivery': {
    key: 'enableCateringDelivery',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable CCPA do not sell button
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-ccpa-do-not-sell-button LaunchDarkly Flag}
   */
  'enable-ccpa-do-not-sell-button': {
    key: 'enable-ccpa-do-not-sell-button',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable checkout upsell items 2
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-checkout-upsell-items-2 LaunchDarkly Flag}
   */
  'enable-checkout-upsell-items-2': {
    key: 'enable-checkout-upsell-items-2',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable claim loyalty points
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-claim-loyalty-points LaunchDarkly Flag}
   */
  'enable-claim-loyalty-points': {
    key: 'enable-claim-loyalty-points',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable consolidated delivery restaurant backend logic
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-consolidated-delivery-restaurant-backend-logic LaunchDarkly Flag}
   */
  'enable-consolidated-delivery-restaurant-backend-logic': {
    key: 'enable-consolidated-delivery-restaurant-backend-logic',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable cookie banner
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableCookieBanner LaunchDarkly Flag}
   */
  'enable-cookie-banner': {
    key: 'enableCookieBanner',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable cookie versioning
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableCookieVersioning LaunchDarkly Flag}
   */
  'enable-cookie-versioning': {
    key: 'enableCookieVersioning',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable curbside
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableCurbside LaunchDarkly Flag}
   */
  'enable-curbside': {
    key: 'enableCurbside',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable default donations to non-zero amount
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-default-donations-to-non-zero-amount LaunchDarkly Flag}
   */
  'enable-default-donations-to-non-zero-amount': {
    key: 'enable-default-donations-to-non-zero-amount',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable delivery
   * @see {@link https://app.launchdarkly.com/projects/default/flags/delivery LaunchDarkly Flag}
   */
  'enable-delivery': {
    key: 'delivery',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable delivery cancellation policy
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableDeliveryCancellationPolicy LaunchDarkly Flag}
   */
  'enable-delivery-cancellation-policy': {
    key: 'enableDeliveryCancellationPolicy',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable delivery only
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-delivery-only LaunchDarkly Flag}
   */
  'enable-delivery-only': {
    key: 'enable-delivery-only',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable delivery watch driver location
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableDeliveryWatchDriverLocation LaunchDarkly Flag}
   */
  'enable-delivery-watch-driver-location': {
    key: 'enableDeliveryWatchDriverLocation',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable customization limits
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-customization-limits LaunchDarkly Flag}
   */
  'enable-customization-limits': {
    key: 'enable-customization-limits',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable checkout outside opening hours, only for delivery
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-delivery-checkout-outside-opening-hours LaunchDarkly Flag}
   */
  'enable-delivery-checkout-outside-opening-hours': {
    key: 'enable-delivery-checkout-outside-opening-hours',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable diagnostic tools
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableDiagnosticTools LaunchDarkly Flag}
   */
  'enable-diagnostic-tools': {
    key: 'enableDiagnosticTools',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable digital wallet migration
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-digital-wallet-migration LaunchDarkly Flag}
   */
  'enable-digital-wallet-migration': {
    key: 'enable-digital-wallet-migration',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable discounts on order receipt
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-discounts-on-order-receipt LaunchDarkly Flag}
   */
  'enable-discounts-on-order-receipt': {
    key: 'enable-discounts-on-order-receipt',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable double vaulting from payment methods
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableDoubleVaultingFromPaymentMethods LaunchDarkly Flag}
   */
  'enable-double-vaulting-from-payment-methods': {
    key: 'enableDoubleVaultingFromPaymentMethods',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable edit cart
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-edit-cart LaunchDarkly Flag}
   */
  'enable-edit-cart': {
    key: 'enable-edit-cart',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable EU nutrition display
   * @see {@link https://app.launchdarkly.com/projects/default/flags/nutritionEuDisplay LaunchDarkly Flag}
   */
  'enable-eu-nutrition-display': {
    key: 'nutritionEuDisplay',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable favorite stores
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableFavoriteStores LaunchDarkly Flag}
   */
  'enable-favorite-stores': {
    key: 'enableFavoriteStores',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable feature donation
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-feature-donation LaunchDarkly Flag}
   */
  'enable-feature-donation': {
    key: 'enable-feature-donation',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable feature nutrition integration
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-feature-nutrition-integration LaunchDarkly Flag}
   */
  'enable-feature-nutrition-integration': {
    key: 'enable-feature-nutrition-integration',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable fees on order receipt
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-fees-on-order-receipt LaunchDarkly Flag}
   */
  'enable-fees-on-order-receipt': {
    key: 'enable-fees-on-order-receipt',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable free order
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-free-order LaunchDarkly Flag}
   */
  'enable-free-order': {
    key: 'enable-free-order',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Force OTA app update
   * @see {@link https://app.launchdarkly.com/projects/default/flags/force-ota-app-update LaunchDarkly Flag}
   */
  'force-ota-app-update': {
    key: 'force-ota-app-update',
    type: 'enum',
    defaultValue: 'none' as 'none' | 'background' | 'optional' | 'required',
  },

  /**
   * Enable FHS loyalty update
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-fhs-loyalty-update LaunchDarkly Flag}
   */
  'enable-fhs-loyalty-update': {
    key: 'enable-fhs-loyalty-update',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Forter fraud
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-forter-fraud LaunchDarkly Flag}
   */
  'enable-forter-fraud': {
    key: 'enable-forter-fraud',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable future ordering
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-future-ordering LaunchDarkly Flag}
   */
  'enable-future-ordering': {
    key: 'enable-future-ordering',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable today available pickup options from backend
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-today-available-pickup-options-from-backend LaunchDarkly Flag}
   */
  'enable-today-available-pickup-options-from-backend': {
    key: 'enable-today-available-pickup-options-from-backend',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Disable pickup window
   * @see {@link https://app.launchdarkly.com/projects/default/flags/disable-pickup-window LaunchDarkly Flag}
   */
  'disable-pickup-window': {
    key: 'disable-pickup-window',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable gift card
   * @see {@link https://app.launchdarkly.com/projects/default/flags/gift-card-payment-method LaunchDarkly Flag}
   */
  'enable-gift-card': {
    key: 'gift-card-payment-method',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable FHS gift cards
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gift-cards LaunchDarkly Flag}
   */
  'enable-fhs-gift-cards': {
    key: 'enable-gift-cards',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable Gift Cards NEW badge
   * Shows a "NEW!" badge next to the Gift Cards link in the account menu
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gift-cards-new-badge LaunchDarkly Flag}
   */
  'enable-gift-cards-new-badge': {
    key: 'enable-gift-cards-new-badge',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable global offers cooldown
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-global-offers-cooldown LaunchDarkly Flag}
   */
  'enable-global-offers-cooldown': {
    key: 'enable-global-offers-cooldown',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable Google Pay
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableGooglePay LaunchDarkly Flag}
   */
  'enable-google-pay': {
    key: 'enableGooglePay',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Google Tag Manager
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-google-tag-manager LaunchDarkly Flag}
   */
  'enable-google-tag-manager': {
    key: 'enable-google-tag-manager',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Google Analytics
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-google-analytics LaunchDarkly Flag}
   */
  'enable-google-analytics': {
    key: 'enable-google-analytics',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable guest and multi-step support page
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableGuestAndMultiStepSupportForm LaunchDarkly Flag}
   */
  'enable-guest-and-multi-step-support-page': {
    key: 'enableGuestAndMultiStepSupportForm',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable hide offers for service mode
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableHideOffersForServiceMode LaunchDarkly Flag}
   */
  'enable-hide-offers-for-service-mode': {
    key: 'enableHideOffersForServiceMode',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable hide loyalty banner welcome message
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableHideLoyaltyBannerWelcomeMessage LaunchDarkly Flag}
   */
  'enable-hide-loyalty-banner-welcome-message': {
    key: 'enableHideLoyaltyBannerWelcomeMessage',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable hide points expiration
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-hide-points-expiration LaunchDarkly Flag}
   */
  'enable-hide-points-expiration': {
    key: 'enable-hide-points-expiration',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable I'm close display
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableImCloseDisplay LaunchDarkly Flag}
   */
  'enable-im-close-display': {
    key: 'enableImCloseDisplay',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable in restaurant loyalty
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-in-restaurant-loyalty LaunchDarkly Flag}
   */
  'enable-in-restaurant-loyalty': {
    key: 'enable-in-restaurant-loyalty',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable in restaurant variations
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-in-restaurant-variations LaunchDarkly Flag}
   */
  'enable-in-restaurant-variations': {
    key: 'enable-in-restaurant-variations',
    type: 'json',
    defaultValue: {
      enableOfferRedemption: true,
      enableRewardRedemption: true,
    } as Record<'enableOfferRedemption' | 'enableRewardRedemption', boolean>,
  },

  /**
   * Enable the Redeem tab in the In-Store Redeem screen (Scan In Restaurant modal)
   * When disabled, only the Earn tab is shown (no reward redemption functionality)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-in-store-rewards-redeem LaunchDarkly Flag}
   */
  'enable-in-store-rewards-redeem': {
    key: 'enable-in-store-rewards-redeem',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable static in-store identification
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-static-in-store-identification LaunchDarkly Flag}
   */
  'enable-static-in-store-identification': {
    key: 'enable-static-in-store-identification',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable internal diagnostic tools
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableInternalDiagnosticTools LaunchDarkly Flag}
   */
  'enable-internal-diagnostic-tools': {
    key: 'enableInternalDiagnosticTools',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable lock on reward image
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-lock-on-reward-image LaunchDarkly Flag}
   */
  'enable-lock-on-reward-image': {
    key: 'enable-lock-on-reward-image',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable loyalty
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-fe LaunchDarkly Flag}
   */
  'enable-loyalty': {
    key: 'enable-loyalty-fe',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable loyalty Aloha integration
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-aloha-integration LaunchDarkly Flag}
   */
  'enable-loyalty-aloha-integration': {
    key: 'enable-loyalty-aloha-integration',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable loyalty offers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-offers LaunchDarkly Flag}
   */
  'enable-loyalty-offers': {
    key: 'enable-loyalty-offers',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable loyalty offers filters
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-offers-filters LaunchDarkly Flag}
   */
  'enable-loyalty-offers-filters': {
    key: 'enable-loyalty-offers-filters',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable loyalty points in header
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-points-in-header LaunchDarkly Flag}
   */
  'enable-loyalty-points-in-header': {
    key: 'enable-loyalty-points-in-header',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable loyalty promo codes
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-promo-codes LaunchDarkly Flag}
   */
  'enable-loyalty-promo-codes': {
    key: 'enable-loyalty-promo-codes',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable loyalty QR and short code
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-qr-and-short-code LaunchDarkly Flag}
   */
  'enable-loyalty-qr-and-short-code': {
    key: 'enable-loyalty-qr-and-short-code',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable loyalty QR code in my code
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-qr-code-in-my-code-page LaunchDarkly Flag}
   */
  'enable-loyalty-qr-code-in-my-code': {
    key: 'enable-qr-code-in-my-code-page',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable loyalty standard offers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-standard-offers LaunchDarkly Flag}
   */
  'enable-loyalty-standard-offers': {
    key: 'enable-loyalty-standard-offers',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable loyalty surprise offers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-surprise-offers LaunchDarkly Flag}
   */
  'enable-loyalty-surprise-offers': {
    key: 'enable-loyalty-surprise-offers',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable menu upsell items
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-menu-upsell-items LaunchDarkly Flag}
   */
  'enable-menu-upsell-items': {
    key: 'enable-menu-upsell-items',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable meter on rewards
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-meter-on-rewards LaunchDarkly Flag}
   */
  'enable-meter-on-rewards': {
    key: 'enable-meter-on-rewards',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable more info optional offer disclaimer
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableMoreInfoOptionalOfferDisclaimer LaunchDarkly Flag}
   */
  'enable-more-info-optional-offer-disclaimer': {
    key: 'enableMoreInfoOptionalOfferDisclaimer',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable move signup after cart
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-move-signup-after-cart LaunchDarkly Flag}
   */
  'enable-move-signup-after-cart': {
    key: 'enable-move-signup-after-cart',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable mParticle QR code
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-mparticle-qr-code LaunchDarkly Flag}
   */
  'enable-mparticle-qr-code': {
    key: 'enable-mparticle-qr-code',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable multiple rewards per order
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-multiple-rewards-per-order LaunchDarkly Flag}
   */
  'enable-multiple-rewards-per-order': {
    key: 'enable-multiple-rewards-per-order',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable my code new UI
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-my-code-new-ui LaunchDarkly Flag}
   */
  'enable-my-code-new-ui': {
    key: 'enable-my-code-new-ui',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable my code payment method
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-my-code-payment-method LaunchDarkly Flag}
   */
  'enable-my-code-payment-method': {
    key: 'enable-my-code-payment-method',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable name change on account page
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-name-change-on-account-page LaunchDarkly Flag}
   */
  'enable-name-change-on-account-page': {
    key: 'enable-name-change-on-account-page',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable numeric phone validation
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-numeric-phone-validation LaunchDarkly Flag}: once proper phone validation is implemented for all regions, this can be removed.
   */
  'enable-numeric-phone-validation': {
    key: 'enable-numeric-phone-validation',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable offer QR code
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-offer-qr-code LaunchDarkly Flag}
   */
  'enable-offer-qr-code': {
    key: 'enable-offer-qr-code',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable offer redemption methods
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-offer-redemption-methods LaunchDarkly Flag}
   */
  'enable-offer-redemption-methods': {
    key: 'enable-offer-redemption-methods',
    type: 'enum',
    defaultValue: 'all' as 'all' | 'mobile' | 'restaurant' | 'disable',
  },

  /**
   * Enable offers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableOffers LaunchDarkly Flag}
   */
  'enable-offers': {
    key: 'enableOffers',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable offers edit cart
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-offers-edit-cart LaunchDarkly Flag}
   */
  'enable-offers-edit-cart': {
    key: 'enable-offers-edit-cart',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable offers mobile
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableOffersMobile LaunchDarkly Flag}
   */
  'enable-offers-mobile': {
    key: 'enableOffersMobile',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable one time password (OTP auth delivery method)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-one-time-password LaunchDarkly Flag}
   */
  'enable-one-time-password': {
    key: 'enable-one-time-password',
    type: 'enum',
    defaultValue: 'All' as 'All' | 'None' | 'Email' | 'SMS',
  },

  /**
   * Enable OneTrust cookie consent banner
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-one-trust-cookie-consent-banner LaunchDarkly Flag}
   */
  'enable-one-trust-cookie-consent-banner': {
    key: 'enable-one-trust-cookie-consent-banner',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable order number generation
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-order-number-generation LaunchDarkly Flag}
   */
  'enable-order-number-generation': {
    key: 'enable-order-number-generation',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable order support
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableOrderSupport LaunchDarkly Flag}
   */
  'enable-order-support': {
    key: 'enableOrderSupport',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable ordering
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableOrdering LaunchDarkly Flag}
   */
  'enable-ordering': {
    key: 'enableOrdering',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable payment error continue
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-payment-error-continue LaunchDarkly Flag}
   */
  'enable-payment-error-continue': {
    key: 'enable-payment-error-continue',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable PayPal payments
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-paypal-payments LaunchDarkly Flag}
   */
  'enable-paypal-payments': {
    key: 'enable-paypal-payments',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable personalized offers template
   * @see {@link https://app.launchdarkly.com/projects/default/flags/fe-personalized-offers-template LaunchDarkly Flag}
   */
  'enable-personalized-offers-template': {
    key: 'fe-personalized-offers-template',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable PLU offer QR code
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-plu-offer-qr-code LaunchDarkly Flag}
   */
  'enable-plu-offer-qr-code': {
    key: 'enable-plu-offer-qr-code',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable Pypestream
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-pypestream LaunchDarkly Flag}
   */
  'enable-pypestream': {
    key: 'enable-pypestream',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable premium combo slots
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-premium-combo-slots LaunchDarkly Flag}
   */
  'enable-premium-combo-slots': {
    key: 'enable-premium-combo-slots',
    type: 'string',
    defaultValue: 'composite' as
      | 'composite'
      | 'delta'
      | 'none'
      | 'direct'
      | 'compositeFallbackDelta',
  },

  /**
   * Enable menu details default combo selection
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-menu-details-default-combo-selection LaunchDarkly Flag}
   */
  'enable-menu-details-default-combo-selection': {
    key: 'enable-menu-details-default-combo-selection',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable product image disclaimer
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-product-image-disclaimer LaunchDarkly Flag}
   */
  'enable-product-image-disclaimer': {
    key: 'enable-product-image-disclaimer',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable service bar on product detail screen for delivery
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-service-mode-bar-on-product-detail-screen-for-delivery LaunchDarkly Flag}
   */
  'enable-service-bar-on-product-detail-screen-for-delivery': {
    key: 'enable-service-mode-bar-on-product-detail-screen-for-delivery',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable promo code at checkout
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enablePromoCodeAtCheckout LaunchDarkly Flag}
   */
  'enable-promo-code-at-checkout': {
    key: 'enablePromoCodeAtCheckout',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable promo code offers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enablePromoCodeOffers LaunchDarkly Flag}
   */
  'enable-promo-code-offers': {
    key: 'enablePromoCodeOffers',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable recent items add to cart
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-recent-items-add-to-cart LaunchDarkly Flag}
   */
  'enable-recent-items-add-to-cart': {
    key: 'enable-recent-items-add-to-cart',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable recent items with modifiers
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableRecentItemsWithModifiers LaunchDarkly Flag}
   */
  'enable-recent-items-with-modifiers': {
    key: 'enableRecentItemsWithModifiers',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable redeem in restaurant primary
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-redeem-in-restaurant-primary LaunchDarkly Flag}
   */
  'enable-redeem-in-restaurant-primary': {
    key: 'enable-redeem-in-restaurant-primary',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable reorder
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-reorder LaunchDarkly Flag}
   */
  'enable-reorder': {
    key: 'enable-reorder',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable request my information
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableRequestMyInformation LaunchDarkly Flag}
   */
  'enable-request-my-information': {
    key: 'enableRequestMyInformation',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable reward page stand alone
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-reward-page-stand-alone LaunchDarkly Flag}
   */
  'enable-reward-page-stand-alone': {
    key: 'enable-reward-page-stand-alone',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable Sanity CDN
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableSanityCdn LaunchDarkly Flag}
   */
  'enable-sanity-cdn': {
    key: 'enableSanityCdn',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable send same OTP code once
   * @see {@link https://app.launchdarkly.com/projects/default/flags/send-same-otp-code-once LaunchDarkly Flag}
   */
  'enable-send-same-otp-code-once': {
    key: 'send-same-otp-code-once',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable resend OTP counter
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-resend-otp-counter LaunchDarkly Flag}
   */
  'enable-resend-otp-counter': {
    key: 'enable-resend-otp-counter',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable service mode cart selection
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableServiceModeCartSelection LaunchDarkly Flag}
   */
  'enable-service-mode-cart-selection': {
    key: 'enableServiceModeCartSelection',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable show address2 before city
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-show-address2-before-city LaunchDarkly Flag}
   */
  'enable-show-address2-before-city': {
    key: 'enable-show-address2-before-city',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable sign up
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableSignUp LaunchDarkly Flag}
   */
  'enable-sign-up': {
    key: 'enableSignUp',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable signup cart button text
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-signup-cart-button-text LaunchDarkly Flag}
   */
  'enable-signup-cart-button-text': {
    key: 'enable-signup-cart-button-text',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable signup communications preselection
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-signup-communications-preselection LaunchDarkly Flag}
   */
  'enable-signup-communications-preselection': {
    key: 'enable-signup-communications-preselection',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable sort offers for service mode
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-sort-offers-for-service-mode LaunchDarkly Flag}
   */
  'enable-sort-offers-for-service-mode': {
    key: 'enable-sort-offers-for-service-mode',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable static menu
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableStaticMenu LaunchDarkly Flag}
   */
  'enable-static-menu': {
    key: 'enableStaticMenu',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable static menu allergens
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-static-menu-allergens LaunchDarkly Flag}
   */
  'enable-static-menu-allergens': {
    key: 'enable-static-menu-allergens',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable store confirmation modal
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableStoreConfirmationModal LaunchDarkly Flag}
   */
  'enable-store-confirmation-modal': {
    key: 'enableStoreConfirmationModal',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable store selection 2.0
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-store-selection-2 LaunchDarkly Flag}
   */
  'enable-store-selection-2-0': {
    key: 'enable-store-selection-2',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable street number after street name
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-street-number-after-street-name LaunchDarkly Flag}
   */
  'enable-street-number-after-street-name': {
    key: 'enable-street-number-after-street-name',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable unverified saved payments
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-unverified-saved-payments LaunchDarkly Flag}
   */
  'enable-unverified-saved-payments': {
    key: 'enable-unverified-saved-payments',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable user saved delivery address phone
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enableUserSavedDeliveryAddressPhone LaunchDarkly Flag}
   */
  'enable-user-saved-delivery-address-phone': {
    key: 'enableUserSavedDeliveryAddressPhone',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable zero bounce error modal
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-zero-bounce-error-modal LaunchDarkly Flag}
   */
  'enable-zero-bounce-error-modal': {
    key: 'enable-zero-bounce-error-modal',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Explicit donation
   * @see {@link https://app.launchdarkly.com/projects/default/flags/explicit-donation LaunchDarkly Flag}
   */
  'explicit-donation': {
    key: 'explicit-donation',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Force restaurant selection for rewards
   * @see {@link https://app.launchdarkly.com/projects/default/flags/force-restaurant-selection-for-rewards LaunchDarkly Flag}
   */
  'force-restaurant-selection-for-rewards': {
    key: 'force-restaurant-selection-for-rewards',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Hide items from nutrition info
   * @see {@link https://app.launchdarkly.com/projects/default/flags/hide-items-from-nutrition-info LaunchDarkly Flag}
   */
  'hide-items-from-nutrition-info': {
    key: 'hide-items-from-nutrition-info',
    type: 'json',
    defaultValue: {
      carbohydrates: false,
      proteinsPer100: false,
      saturatedFat: false,
      calories: false,
      energyKJ: false,
      sugarPer100: false,
      saltPer100: false,
      fiber: false,
      fatPer100: false,
      cholesterol: false,
      proteins: false,
      transFat: false,
      carbohydratesPer100: false,
      salt: false,
      sugar: false,
      saturatedFatPer100: false,
      weight: true,
      sodium: false,
      fat: false,
      caloriesPer100: false,
      energyKJPer100: false,
    },
  },

  /**
   * Hide tip amount checkout
   * @see {@link https://app.launchdarkly.com/projects/default/flags/hide-tip-amount-checkout LaunchDarkly Flag}
   */
  'hide-tip-amount-checkout': {
    key: 'hide-tip-amount-checkout',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Hide all calories outside of the nutrition explorer
   * @see {@link https://app.launchdarkly.com/projects/default/flags/hide-ui-calories LaunchDarkly Flag}
   */
  'hide-ui-calories': {
    key: 'hide-ui-calories',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Loyalty in restaurant status poll interval (ms)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/loyalty-in-restaurant-status-poll-interval-ms LaunchDarkly Flag}
   */
  'loyalty-in-restaurant-status-poll-interval-ms': {
    key: 'loyalty-in-restaurant-status-poll-interval-ms',
    type: 'number',
    defaultValue: 2000,
  },

  /**
   * Mobile cart upsell location
   * @see {@link https://app.launchdarkly.com/projects/default/flags/mobileCartUpsellLocation LaunchDarkly Flag}
   */
  'mobile-cart-upsell-location': {
    key: 'mobileCartUpsellLocation',
    type: 'enum',
    defaultValue: 'aboveYourCart' as 'aboveYourCart' | 'abovePaymentDetails',
  },

  /**
   * My account fields variations
   * @see {@link https://app.launchdarkly.com/projects/default/flags/my-account-fields-variations LaunchDarkly Flag}
   */
  'my-account-fields-variations': {
    key: 'my-account-fields-variations',
    type: 'json',
    defaultValue: {
      agreesToTermsOfService: true,
      country: false,
      dob: true,
      email: true,
      name: true,
      phone: true,
      wantsPromotionalEmails: true,
      zip: false,
    },
  },

  /**
   * Order locator tabs
   * @see {@link https://app.launchdarkly.com/projects/default/flags/order-locator-tabs LaunchDarkly Flag}
   */
  'order-locator-tabs': {
    key: 'order-locator-tabs',
    type: 'json',
    defaultValue: {
      '0': 'nearby',
      '1': 'favorite',
      '2': 'recent',
    },
  },

  /**
   * Override checkout catering limit (cents)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/CheckoutCateringLimitOverrideCents LaunchDarkly Flag}
   */
  'override-checkout-catering-limit': {
    key: 'CheckoutCateringLimitOverrideCents',
    type: 'number',
    defaultValue: 0,
  },

  /**
   * Override checkout catering minimum (cents)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/checkoutCateringMinimumOverrideCents LaunchDarkly Flag}
   */
  'override-checkout-catering-minimum': {
    key: 'checkoutCateringMinimumOverrideCents',
    type: 'number',
    defaultValue: 75_00,
  },

  /**
   * Override checkout delivery minimum (cents)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/checkoutDeliveryMinimumOverrideCents LaunchDarkly Flag}
   */
  'override-checkout-delivery-minimum': {
    key: 'checkoutDeliveryMinimumOverrideCents',
    type: 'number',
    defaultValue: 0,
  },

  /**
   * Override checkout limit (cents)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/CheckoutLimitOverrideCents LaunchDarkly Flag}
   */
  'override-checkout-limit': {
    key: 'CheckoutLimitOverrideCents',
    type: 'number',
    defaultValue: 300_00,
  },

  /**
   * Payment field variations
   * @see {@link https://app.launchdarkly.com/projects/default/flags/payment-fields-variations LaunchDarkly Flag}
   */
  'payment-field-variations': {
    key: 'payment-fields-variations',
    type: 'json',
    defaultValue: {
      zip: true,
      cvv: true,
      addressLine1: false,
      addressLine2: false,
      city: false,
      name: true,
      expiration: true,
      state: false,
      country: false,
      cardNumber: true,
    },
  },

  /**
   * Phone number within QR code widget
   * @see {@link https://app.launchdarkly.com/projects/default/flags/phone-number-within-qrcode-widget LaunchDarkly Flag}
   */
  'phone-number-within-qrcode-widget': {
    key: 'phone-number-within-qrcode-widget',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Supported card brands variations
   * @see {@link https://app.launchdarkly.com/projects/default/flags/supported-card-brands-variations LaunchDarkly Flag}
   */
  'supported-card-brands-variations': {
    key: 'supported-card-brands-variations',
    type: 'json',
    defaultValue: ['amex', 'diners', 'discover', 'jcb', 'mc', 'visa'],
  },

  /**
   * Radius for store locator
   * @see {@link https://app.launchdarkly.com/projects/default/flags/radius-for-store-locator LaunchDarkly Flag}
   */
  'radius-for-store-locator': {
    key: 'radius-for-store-locator',
    type: 'number',
    defaultValue: 32_000,
  },

  /**
   * Reset cart reset store timeout
   * @see {@link https://app.launchdarkly.com/projects/default/flags/resetStoreResetCartTimeout LaunchDarkly Flag}
   */
  'reset-cart-reset-store-timeout': {
    key: 'resetStoreResetCartTimeout',
    type: 'number',
    defaultValue: 0,
  },

  /**
   * Reset cart timeout (hours)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/reset-cart-timeout-hrs LaunchDarkly Flag}
   */
  'reset-cart-timeout-hrs': {
    key: 'reset-cart-timeout-hrs',
    type: 'number',
    defaultValue: 0.25,
  },

  /**
   * Send postal code only for First Data payment
   * @see {@link https://app.launchdarkly.com/projects/default/flags/send-postal-code-only-for-first-data-payment LaunchDarkly Flag}
   */
  'send-postal-code-only-for-first-data-payment': {
    key: 'send-postal-code-only-for-first-data-payment',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable delivery fee dialog on delivery address select
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-delivery-fee-dialog-on-delivery-address-select LaunchDarkly Flag}
   */
  'enable-delivery-fee-dialog-on-delivery-address-select': {
    key: 'enable-delivery-fee-dialog-on-delivery-address-select',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Show increased delivery fees modal
   * @see {@link https://app.launchdarkly.com/projects/default/flags/show-increased-delivery-fees-modal LaunchDarkly Flag}
   */
  'show-increased-delivery-fees-modal': {
    key: 'show-increased-delivery-fees-modal',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Show delivery fees breakdown on modal
   * @see {@link https://app.launchdarkly.com/projects/default/flags/show-delivery-fees-breakdown-on-dialog LaunchDarkly Flag}
   */
  'show-delivery-fees-breakdown-on-modal': {
    key: 'show-delivery-fees-breakdown-on-dialog',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Show delivery fees on cart
   * @see {@link https://app.launchdarkly.com/projects/default/flags/show-delivery-fees-on-cart LaunchDarkly Flag}
   */
  'show-delivery-fees-on-cart': {
    key: 'show-delivery-fees-on-cart',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Show delivery fee on service mode bar
   * @see {@link https://app.launchdarkly.com/projects/default/flags/show-delivery-fee-on-service-mode-bar LaunchDarkly Flag}
   */
  'show-delivery-fee-on-service-mode-bar': {
    key: 'show-delivery-fee-on-service-mode-bar',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Show delivery fees info
   * @see {@link https://app.launchdarkly.com/projects/default/flags/show-delivery-fees-info LaunchDarkly Flag}
   */
  'show-delivery-fees-info': {
    key: 'show-delivery-fees-info',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Show ordering issue info
   * @see {@link https://app.launchdarkly.com/projects/default/flags/show-ordering-issue-info LaunchDarkly Flag}
   */
  'show-ordering-issue-info': {
    key: 'show-ordering-issue-info',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Sign up fields variations
   * @see {@link https://app.launchdarkly.com/projects/default/flags/sign-up-fields-variations LaunchDarkly Flag}
   */
  'sign-up-fields-variations': {
    key: 'sign-up-fields-variations',
    type: 'json',
    defaultValue: {
      gender: false,
      zip: false,
      wantsPromotionalEmails: true,
      name: true,
      phone: true,
      country: true,
      dob: true,
      agreesToTermsOfService: true,
      email: true,
      favoriteStoreSelector: false,
    },
  },

  /**
   * Skip loyalty store validation
   * @see {@link https://app.launchdarkly.com/projects/default/flags/skip-loyalty-store-validation LaunchDarkly Flag}
   */
  'skip-loyalty-store-validation': {
    key: 'skip-loyalty-store-validation',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Store card button options
   * @see {@link https://app.launchdarkly.com/projects/default/flags/store-card-button-options LaunchDarkly Flag}
   */
  'store-card-button-options': {
    key: 'store-card-button-options',
    type: 'json',
    defaultValue: ['info', 'order'],
  },

  /**
   * 3DS First Data submit timeout
   * @see {@link https://app.launchdarkly.com/projects/default/flags/first-data-3ds-submit-timeout LaunchDarkly Flag}
   */
  'three-ds-first-data-submit-timeout': {
    key: 'first-data-3ds-submit-timeout',
    type: 'number',
    defaultValue: 3000,
  },

  /**
   * Tiered catering delivery fees
   * @see {@link https://app.launchdarkly.com/projects/default/flags/tiered-catering-delivery-fees LaunchDarkly Flag}
   */
  'tiered-catering-delivery-fees': {
    key: 'tiered-catering-delivery-fees',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Tiered delivery fees
   * @see {@link https://app.launchdarkly.com/projects/default/flags/tiered-delivery-fees LaunchDarkly Flag}
   */
  'tiered-delivery-fees': {
    key: 'tiered-delivery-fees',
    type: 'json',
    defaultValue: {
      '0': {
        app: {
          discount: 0,
          fee: 399,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        googleFoodOrdering: {
          discount: 0,
          fee: 0,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        kiosk: {
          discount: 0,
          fee: 0,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        web: {
          discount: 0,
          fee: 399,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
      },
      '1000': {
        app: {
          discount: 0,
          fee: 399,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        googleFoodOrdering: {
          discount: 0,
          fee: 0,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        kiosk: {
          discount: 0,
          fee: 0,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        web: {
          discount: 0,
          fee: 399,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
      },
      '2000': {
        app: {
          discount: 0,
          fee: 399,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        googleFoodOrdering: {
          discount: 0,
          fee: 0,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        kiosk: {
          discount: 0,
          fee: 0,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
        web: {
          discount: 0,
          fee: 399,
          serviceFeePercent: 0,
          smallCartFee: 0,
        },
      },
    },
  },

  /**
   * Tip percent threshold (cents)
   * @see {@link https://app.launchdarkly.com/projects/default/flags/tipPercentThresholdCents LaunchDarkly Flag}
   */
  'tip-percent-threshold-cents': {
    key: 'tipPercentThresholdCents',
    type: 'number',
    defaultValue: 0,
  },

  /**
   * Tips for store employees
   * @see {@link https://app.launchdarkly.com/projects/default/flags/tips-for-store-employees LaunchDarkly Flag}
   */
  'tip-for-store-employees': {
    key: 'tips-for-store-employees',
    type: 'json',
    defaultValue: {
      enabled: true,
      tipAmounts: {
        $1: 100,
        $2: 200,
        $3: 300,
        None: 0,
      },
    },
  },

  /**
   * Use high volume support message
   * @see {@link https://app.launchdarkly.com/projects/default/flags/use-high-volume-support-msg LaunchDarkly Flag}
   */
  'use-high-volume-support-msg': {
    key: 'use-high-volume-support-msg',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable menu service data
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-menu-service-data LaunchDarkly Flag}
   */
  'enable-menu-service-data': {
    key: 'enable-menu-service-data',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable prepaid payment methods
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-prepaid-payment-methods LaunchDarkly Flag}
   */
  'enable-prepaid-payment-methods': {
    key: 'enable-prepaid-payment-methods',
    type: 'json',
    defaultValue: {
      APPLE_PAY: true,
      CREDIT: true,
      EXISTING_METHOD: true,
      GOOGLE_PAY: true,
      ONE_TIME_METHOD: true,
    },
  },

  /**
   * Enable show picker aspects in static menu
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-show-picker-aspects-in-static-menu LaunchDarkly Flag}
   */
  'enable-show-picker-aspects-in-static-menu': {
    key: 'enable-show-picker-aspects-in-static-menu',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable switch service mode modal
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-switch-service-mode-modal LaunchDarkly Flag}
   */
  'enable-switch-service-mode-modal': {
    key: 'enable-switch-service-mode-modal',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable delivery fee breakdown
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-delivery-fee-breakdown LaunchDarkly Flag}
   */
  'enable-delivery-fee-breakdown': {
    key: 'enable-delivery-fee-breakdown',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable cooldown toast info
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-cooldown-toast-info LaunchDarkly Flag}
   */
  'enable-cooldown-toast-info': {
    key: 'enable-cooldown-toast-info',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Order cart version
   * @see {@link https://app.launchdarkly.com/projects/default/flags/order-cart-version LaunchDarkly Flag}
   */
  'order-cart-version': {
    key: 'order-cart-version',
    type: 'number',
    defaultValue: 1,
  },

  /**
   * Enable rewards static page
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-rewards-static-page LaunchDarkly Flag}
   */
  'enable-rewards-static-page': {
    key: 'enable-rewards-static-page',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable offers static page
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-offers-static-page LaunchDarkly Flag}
   */
  'enable-offers-static-page': {
    key: 'enable-offers-static-page',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Determines what sections are displayed in the /account page
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-account-sections-variations LaunchDarkly Flag}
   */
  'enable-account-sections-variations': {
    key: 'enable-account-sections-variations',
    type: 'json',
    defaultValue: {
      accountInfo: true,
      earnPoints: false,
      paymentMethods: true,
      recentOrders: true,
      submitFeedback: true,
      userPreferences: false,
    },
  },

  /**
   * Validates the user's region is equal to the current region
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-account-region-verification LaunchDarkly Flag}
   */
  'enable-account-region-verification': {
    key: 'enable-account-region-verification',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable new payments frontend
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-new-payments-frontend LaunchDarkly Flag}
   * @todo probably delete
   */
  'enable-new-payments-frontend': {
    key: 'enable-new-payments-frontend',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Loyalty offers refactor
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-loyalty-offers-v2-fe LaunchDarkly Flag}
   */
  'enable-loyalty-offers-v2-fe': {
    key: 'enable-loyalty-offers-v2-fe',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Controls the error code we are throwing to when we identify that given email or phoneNumber are not in the system
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-user-not-found-mask-on-auth-flows LaunchDarkly Flag}
   */
  'enable-user-not-found-mask-on-auth-flow': {
    key: 'enable-user-not-found-mask-on-auth-flows',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * auth-flow-use-backend-session-id
   * @see {@link https://app.launchdarkly.com/projects/default/flags/auth-flow-use-backend-session-id LaunchDarkly Flag}
   */
  'auth-flow-use-backend-session-id': {
    key: 'auth-flow-use-backend-session-id',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * New card payments will be vaulted with a standalone call to add payment method
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-vault-after-making-one-time-payment LaunchDarkly Flag}
   */
  'enable-vault-after-making-one-time-payment': {
    key: 'enable-vault-after-making-one-time-payment',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Controls use of 2d barcode vs QRCode
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-legacy-loyalty-barcode LaunchDarkly Flag}
   */
  'enable-legacy-loyalty-barcode': {
    key: 'enable-legacy-loyalty-barcode',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable future order loyalty redemption
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-future-order-loyalty-redemption LaunchDarkly Flag}
   */
  'enable-future-order-loyalty-redemption': {
    key: 'enable-future-order-loyalty-redemption',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Homepage alert
   * @see {@link https://app.launchdarkly.com/projects/default/flags/homepage-alert LaunchDarkly Flag}
   */
  'homepage-alert': {
    key: 'homepage-alert',
    type: 'json',
    defaultValue: {} as {
      text?: string;
      link?: {
        text: string;
        href: string;
      };
    },
  },

  /**
   * Temporarily hide delivery CTA
   * @see {@link https://app.launchdarkly.com/projects/default/flags/temp-hide-delivery-cta LaunchDarkly Flag}
   */
  'temp-hide-delivery-cta': {
    key: 'temp-hide-delivery-cta',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * Enable catering CTA
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-catering-cta LaunchDarkly Flag}
   */
  'enable-catering-cta': {
    key: 'enable-catering-cta',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Enable restaurant query cache
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-restaurant-query-cache LaunchDarkly Flag}
   */
  'enable-restaurant-query-cache': {
    key: 'enable-restaurant-query-cache',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Home catering URL
   * @see {@link https://app.launchdarkly.com/projects/default/flags/home-catering-url LaunchDarkly Flag}
   */
  'home-catering-url': {
    key: 'home-catering-url',
    type: 'string',
    defaultValue: 'https://www.ezcater.com/brand/pvt/firehouse-subs',
  },

  /**
   * Redirect old pages
   * @see {@link https://app.launchdarkly.com/projects/default/flags/redirect-old-page LaunchDarkly Flag}
   */
  'redirect-old-pages': {
    key: 'redirect-old-page',
    type: 'json',
    defaultValue: [] as Array<{ searchPattern: Array<string>; to: string }>,
  },

  /**
   * Enable order status refetch to check if the order was successfully placed in cases where we have timeouts.
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-order-status-refetch-on-timeout-at-checkout LaunchDarkly Flag}
   */
  'enable-order-status-refetch-on-timeout-at-checkout': {
    key: 'enable-order-status-refetch-on-timeout-at-checkout',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * Minimum App version
   * @see {@link https://app.launchdarkly.com/projects/default/flags/minimum-app-version LaunchDarkly Flag}
   */
  'minimum-app-version': {
    key: 'minimum-app-version',
    type: 'string',
    defaultValue: '11.14.0',
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-mergePrepaid LaunchDarkly Flag}
   */
  'enable-gateway-mergePrepaid': {
    key: 'enable-gateway-mergePrepaid',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-purchasePrepaid LaunchDarkly Flag}
   */
  'enable-gateway-purchasePrepaid': {
    key: 'enable-gateway-purchasePrepaid',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-prepaidsReload LaunchDarkly Flag}
   */
  'enable-gateway-prepaidsReload': {
    key: 'enable-gateway-prepaidsReload',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-updateMe LaunchDarkly Flag}
   */
  'enable-gateway-updateMe': {
    key: 'enable-gateway-updateMe',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-createLoyaltyUser LaunchDarkly Flag}
   */
  'enable-gateway-createLoyaltyUser': {
    key: 'enable-gateway-createLoyaltyUser',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-userAccounts LaunchDarkly Flag}
   */
  'enable-gateway-userAccounts': {
    key: 'enable-gateway-userAccounts',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-deleteAccount LaunchDarkly Flag}
   */
  'enable-gateway-deleteAccount': {
    key: 'enable-gateway-deleteAccount',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-getPrepaidsBalance LaunchDarkly Flag}
   */
  'enable-gateway-getPrepaidsBalance': {
    key: 'enable-gateway-getPrepaidsBalance',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-addCreditAccount LaunchDarkly Flag}
   */
  'enable-gateway-addCreditAccount': {
    key: 'enable-gateway-addCreditAccount',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-encryptionDetails LaunchDarkly Flag}
   */
  'enable-gateway-encryptionDetails': {
    key: 'enable-gateway-encryptionDetails',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-addGiftAccount LaunchDarkly Flag}
   */
  'enable-gateway-addGiftAccount': {
    key: 'enable-gateway-addGiftAccount',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-prepaidsTransactions LaunchDarkly Flag}
   */
  'enable-gateway-prepaidsTransactions': {
    key: 'enable-gateway-prepaidsTransactions',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-prepaidsMerge LaunchDarkly Flag}
   */
  'enable-gateway-prepaidsMerge': {
    key: 'enable-gateway-prepaidsMerge',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-restaurants LaunchDarkly Flag}
   */
  'enable-gateway-restaurants': {
    key: 'enable-gateway-restaurants',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-restaurant LaunchDarkly Flag}
   */
  'enable-gateway-restaurant': {
    key: 'enable-gateway-restaurant',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-deliveryRestaurant LaunchDarkly Flag}
   */
  'enable-gateway-deliveryRestaurant': {
    key: 'enable-gateway-deliveryRestaurant',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-me LaunchDarkly Flag}
   */
  'enable-gateway-me': {
    key: 'enable-gateway-me',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-createSupportCase LaunchDarkly Flag}
   */
  'enable-gateway-createSupportCase': {
    key: 'enable-gateway-createSupportCase',
    type: 'boolean',
    defaultValue: false,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-redeemCoupon LaunchDarkly Flag}
   */
  'enable-gateway-redeemCoupon': {
    key: 'enable-gateway-redeemCoupon',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-listUserCouponTokens LaunchDarkly Flag}
   */
  'enable-gateway-listUserCouponTokens': {
    key: 'enable-gateway-listUserCouponTokens',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-evaluateUserOffers LaunchDarkly Flag}
   */
  'enable-gateway-evaluateUserOffers': {
    key: 'enable-gateway-evaluateUserOffers',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-requestMyInfo LaunchDarkly Flag}
   */
  'enable-gateway-requestMyInfo': {
    key: 'enable-gateway-requestMyInfo',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-signUpComplete LaunchDarkly Flag}
   */
  'enable-gateway-signUpComplete': {
    key: 'enable-gateway-signUpComplete',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-userFavorites LaunchDarkly Flag}
   */
  'enable-gateway-userFavorites': {
    key: 'enable-gateway-userFavorites',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-userGeo LaunchDarkly Flag}
   */
  'enable-gateway-userGeo': {
    key: 'enable-gateway-userGeo',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-signUp LaunchDarkly Flag}
   */
  'enable-gateway-signUp': {
    key: 'enable-gateway-signUp',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-createLoginForVendor LaunchDarkly Flag}
   */
  'enable-gateway-createLoginForVendor': {
    key: 'enable-gateway-createLoginForVendor',
    type: 'boolean',
    defaultValue: true,
  },

  /**
   * @see {@link https://app.launchdarkly.com/projects/default/flags/enable-gateway-resendVerificationEmail LaunchDarkly Flag}
   */
  'enable-gateway-resendVerificationEmail': {
    key: 'enable-gateway-resendVerificationEmail',
    type: 'boolean',
    defaultValue: true,
  },
});

export type AllFlagsType = {
  [definitionKey in keyof typeof flagDefinitions]: (typeof flagDefinitions)[definitionKey]['defaultValue'];
};
